import ko from "knockout";
import "flow/extensions/koMeta";
import { MaybeObservable, MaybeObservableAttributes } from "flow/interfaces/MaybeObservable";
import viewHtml from "./radiobutton.html";
import createEnabler from "flow/koHelpers/createEnablerDisabler";
import { selectLabel } from "flow/koHelpers/selectParam";
import { interceptAttributesWithDefaults } from "flow/koHelpers/interceptAttributes";

export interface IRadioButtonParams {
    checked: MaybeObservable<boolean>;
    text?: MaybeObservable<string>;
    enable?: MaybeObservable<boolean>;
    disable?: MaybeObservable<boolean>;
    meta?: MaybeObservable<string>;
    value?: MaybeObservable<any>;
    name: MaybeObservable<string>;
    attr?: MaybeObservableAttributes;
    suppressErrorMessage?: boolean;
}

ko.components.register("ko-radiobutton", {
    viewModel: function (params: IRadioButtonParams) {
        this.checked = params.checked;

        this.takeInnerHtml = false;

        if (params.meta || params.text) {
            this.text = selectLabel(params.meta, params.text);
        } else {
            this.takeInnerHtml = true;
        }

        this.enable = createEnabler(params.enable, params.disable);

        this.value = params.value;

        this.attributes = interceptAttributesWithDefaults({ name: params.name }, params.attr);

        this.suppressErrorMessage = params.suppressErrorMessage ?? false;
    },
    template: viewHtml,
    synchronous: true
});
